import './index.scss';
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { changeToManageMode } from '../../../js/actions/appModeActionCreators';
import ManagePageLayout from '../../common/PageLayout/Manage';

const IntroPage = React.createClass({
    propTypes: {
        alignMode: PropTypes.func.isRequired
    },
    componentDidMount: function () {
        this.props.alignMode();
    },
    render: function () {
        return (
            <ManagePageLayout>
                <div className="pure-g">
                    <div className="pure-u-1-1 Homepage">
                        <h1>Welcome to <em>SQL Clone</em></h1>
                        <p>SQL Clone takes the pain out of creating and managing multiple copies of production databases, helping you and your team deliver new features and upgrades fast.</p>
                    </div>
                </div>
            </ManagePageLayout>
        );
    }
});

const mapDispatchToProps = (dispatch) => {
  return {
    alignMode: () => {
        dispatch(changeToManageMode());
    }
  };
};

export default connect(null, mapDispatchToProps)(IntroPage);



// WEBPACK FOOTER //
// ./src/components/home/IntroPage/index.jsx